import { render, staticRenderFns, recyclableRender, components } from "./seleCity.vue?vue&type=template&id=2fd25746&scoped=true&"
var renderjs
import script from "./seleCity.vue?vue&type=script&lang=js&"
export * from "./seleCity.vue?vue&type=script&lang=js&"
import style0 from "./seleCity.vue?vue&type=style&index=0&id=2fd25746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd25746",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/seleCity/seleCity.vue"
export default component.exports